"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUID = void 0;
var uuid_1 = require("uuid");
var UUID = /** @class */ (function () {
    function UUID(uuid) {
        this.value = uuid;
    }
    UUID.randomUUID = function () {
        return new UUID(uuid_1.v4());
    };
    UUID.prototype.toString = function () {
        return this.value;
    };
    return UUID;
}());
exports.UUID = UUID;
//# sourceMappingURL=GaiaScalars.js.map